export default __webpack_public_path__ + "static/media/second-step-cg-create-plwd.97d98d00.png";